import { getDomain } from './domain';

export const setNToken = (token: string) => {
  document.cookie = 'n_token=; Max-Age=0; path=/';
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `n_token=${token};path=/;expires=${expires.toUTCString()};SameSite=Lax;${getDomain()}`;
};

export const getCookieValue = (cookieName: string): string | null => {
  const name = `${encodeURIComponent(cookieName)}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split('; ');
  const cookie = cookieArray.find((c) => c.startsWith(name));
  return cookie ? cookie.substring(name.length) : null;
};

export const removeCookie = (name: string) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
